export const startEndMargin = 0.12;
export let sturzRiegelHeight = null; //m
export const setSturzRiegelHeight = (value) => {
    sturzRiegelHeight = value;
};
